import { Radio } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import { useDispatch } from 'react-redux';
import { deleteAddress, fetchAllAddress } from '../../../State/customer/AddressSlice';
import { useAppDispatch } from '../../../State/Store';
import { Address } from '../../../types/userType';



interface AddressCardProp{
    address:Address,
    fullName:string|undefined,
    setSelectedAddress: React.Dispatch<React.SetStateAction<number|null>>;
  selectedAddress:number | null
}
export const AddressCard:React.FC<AddressCardProp> = ({address,fullName,setSelectedAddress,selectedAddress}) => {
    const dispatch = useAppDispatch()
    const handleClick = () => {
      if(address.id!=undefined){

        setSelectedAddress(address.id)
      } 
    }

  const handleRemoveAddress = async(addressId:number|undefined) => { 
    
      if(addressId!=undefined){
        await  dispatch(deleteAddress(addressId)).unwrap()
    

      }
   }
  return (
    <div className='relative w-full'>
     <div  className="lg:p-5 p-2 space-x-5  border rounded-md flex justify-start  align-middle ">
        <div className='' >
            {/* Without comparing selectedAddress to address.id, the Radio button cannot determine if it is the selected one. because checked expect a boolean instead of number or null */}
            <Radio
              onClick={handleClick}
            checked={selectedAddress===address.id}
            value={address.id}
            name='radio-button'
            />
        </div>
        <div className="space-y-3">
            <h1 className='lg:text-2xl md:text-md italic text-primary'>{fullName}</h1>
            <p className='w-[320px] lg:text-xl text-md'>{address.postalCode} {address.streetName} {address.city}</p>
            <p className='lg:text-md text-sm'><strong>Mobile:</strong>{address.mobile}</p>
        </div>
    </div>
        <div className="absolute top-0 right-2">
            <IconButton onClick={()=>{handleRemoveAddress(address.id)}}  sx={{color:red[400]}}>
                <Close/>
            </IconButton>
        </div>
    </div>
   
  )
}
